import type { SpeedState } from "app/speed/speedState";
import { INITIAL_STATE, SpeedAction, speedReducer } from "app/speed/speedState";
import useResetableStorage from "app/utils/useResetableStorage";
import { createContext, useCallback, useContext, useReducer } from "react";
export function useSpeedReducer(storageKey: string) {
  const serializer = (state: SpeedState): string => JSON.stringify(state);
  const deserializer = (value: string): SpeedState => JSON.parse(value);

  const [savedState, setSaveState] = useResetableStorage(
    storageKey,
    INITIAL_STATE,
    { raw: false, serializer, deserializer },
  );

  const reducerLocalStorage = useCallback(
    (state: SpeedState, action: SpeedAction) => {
      const newState = speedReducer(state, action);
      setSaveState(newState);
      return newState;
    },
    [setSaveState],
  );

  return useReducer(reducerLocalStorage, savedState || INITIAL_STATE);
}

export const SpeedDispatchContext = createContext<React.Dispatch<SpeedAction>>(
  () => {},
);

export function useSpeedActionDispatch() {
  return useContext(SpeedDispatchContext);
}

export const SpeedContext = createContext<SpeedState>(INITIAL_STATE);

export function useSpeedState() {
  return useContext(SpeedContext);
}
